import React from "react";

import { Link } from "react-router-dom";

import { ImgWrapper } from "./styled";
const BoxContainer = () => {
  return <ImgWrapper as={Link} to="/mint"></ImgWrapper>;
};

export default BoxContainer;
